import "./Toast.scss"

import { Button, Icon } from "@deligoo/ui"
import { toast } from "react-toastify"

import cls from "./AppUpdateToast.module.scss"

export const AppUpdateToast = ({ onButtonClick }: { onButtonClick: () => void }) => {
  return (
    <div>
      <span className={cls.info}>
        <Icon name="warnings" color="warning" gutter="right" />
        Dostępna jest nowa wersja aplikacji.
      </span>
      <Button className={cls.updateButton} size="large" color="success" onClick={onButtonClick} fullWidth>
        Zaktualizuj
      </Button>
    </div>
  )
}

export const showAppUpdateToast = (onButtonClick: () => void) => {
  const toastId = "appUpdate"

  return toast(<AppUpdateToast onButtonClick={onButtonClick} />, {
    toastId,
    className: cls.appUpdateToast,
    position: "bottom-right",
    autoClose: false,
    closeButton: false,
    closeOnClick: false,
    draggable: false,
  })
}
